<template>
    <div class="prelative">
        <fieldset id="companysearch-fieldset" class="py-2">
            <legend>{{ $l10n.__("Chercher dans l'annuaire des sociétés") }}</legend>
            <TemplateForm
                :context="context"
                :thirdName="thirdName"
                :district="district"
                :searching="searching"
                @companies="companiesFetched"
                @submit="searchCompanies"
                @countryCodeSelected="countryCodeSelected"
            />
            <div v-if="companiesResult" id="companysearch-result" class="prelative">
                <div class="resultInfos">
                    <span class="nb_results ml-2">
                        {{
                            $l10n.n__(
                                '%(nb)s société trouvée',
                                '%(nb)s sociétés trouvées',
                                companiesResult.length,
                                { nb: companiesResult.length },
                            )
                        }}
                    </span>
                </div>
                <div class="resultList row gutters1 mxh-320 ovy-auto">
                    <component
                        :is="`${countryCode}_results`"
                        :countryCode="countryCode"
                        :companies="companiesResult"
                        @companySelected="fillThird"
                    />
                </div>
            </div>
        </fieldset>
    </div>
</template>

<script>
import TemplateForm from './TemplateForm.vue';
import FRResult from './FR_results.vue';
import GBResult from './GB_results.vue';
import Feature from 'Services/Feature';

export default {
    components: {
        TemplateForm,
        GB_results: GBResult,
        FR_results: FRResult,
    },
    props: {
        context: {
            type: String,
            required: false,
        },
        thirdName: {
            type: String,
            required: false,
        },
        district: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            companiesResult: null,
            isAvalaible: true,
            searching: false,
            countryCode: null,
        };
    },
    methods: {
        fillThird(payload) {
            this.context === 'update'
                ? this.fillUpdatedThird(payload.companyId, payload.queryParams)
                : this.fillThirdForm(payload.companyId, payload.queryParams);
        },
        fetchCompany(companyId, queryParams) {
            return new Promise((resolve, reject) => {
                window.SellsyJS.WebServiceCaller.get(
                    `/companysearch/search/${companyId}`,
                    queryParams,
                    (result) => {
                        if (result.error && result.error.message) {
                            reject(result.error.message);
                        } else {
                            resolve(result);
                        }
                    },
                    (error) => {
                        reject(window.i18n.__('Une erreur est survenue'));
                    },
                );
            });
        },
        addressFormatted(address) {
            let addressFormatted = '';

            if (address.number) {
                addressFormatted += address.number + ' ';
            }

            if (address.part1) {
                addressFormatted += address.part1 + ' ';
            }

            if (address.part2) {
                addressFormatted += address.part2 + ' ';
            }

            if (address.zipCode) {
                addressFormatted += address.zipCode + ' ';
            }

            if (address.town) {
                addressFormatted += address.town + ' ';
            }

            if (address.country) {
                addressFormatted += address.country + '';
            }
            return addressFormatted;
        },
        fillThirdForm(companyId, queryParams) {
            this.searching = true;
            //fetch all company informations
            this.fetchCompany(companyId, queryParams).then(
                (company) => {
                    // Reset fields
                    $('#thirdaddress_part1').val('');
                    $('#thirdaddress_part2').val('');
                    $('#thirdaddress_zip').tokenInput('clear');
                    $('#thirdcontact_forename').val('');
                    $('#thirdcontact_name').val('').trigger('input');
                    $('#thirdcontact_position').val('');

                    // Fill fields
                    $('[id$=thirdaddress_countrycode]').val(queryParams.countryCode);
                    $('[id$=corp_siren]').val(companyId);
                    $('[id$=label_corp_siren]').text(
                        window.CompanySearch.getLabelForCountry(
                            'companyId',
                            queryParams.countryCode,
                        ),
                    );

                    $('[id$=corp_siret]').val(company.siret);
                    $('[id$=corp_apenaf]').val(company.companyJobCode);

                    // Localized label
                    $('[id$=label_corp_apenaf]').text(
                        window.CompanySearch.getLabelForCountry('jobCode', queryParams.countryCode),
                    );

                    $('[id$=corp_business_segment]').val(company.businessSegment);

                    $('[id$=corp_type]').val(company.companyType);
                    $('[id$=corp_name]').val(company.name).trigger('input');

                    if (Feature.isEnabled('company-search-scraping-enrichment')) {
                        $('[id$=corp_tel]').val(company?.businessPhone);
                        $('[id$=corp_email]').val(company?.businessEmail);

                        $('[id$=corp_web]').val(company?.urls?.website);
                        $('[id$=corp_facebook]').val(company?.urls?.facebook);
                        $('[id$=corp_instagram]').val(company?.urls?.instagram);
                        $('[id$=corp_linkedin]').val(company?.urls?.linkedin);
                        $('[id$=corp_twitter]').val(company?.urls?.twitter);
                    }

                    if (company.address) {
                        var number = '';
                        if (company.address.number) {
                            number = company.address.number + ' ';
                        }

                        if (!$('#thirdaddress_name').is(':visible')) {
                            $('#address_wrap').click();
                        }

                        const addressParts = [];
                        if (company.address.part1) {
                            addressParts.push(number + company.address.part1);
                        }
                        if (company.address.part2) {
                            addressParts.push(company.address.part2);
                        }
                        addressParts.forEach((part, index) => {
                            $(`#thirdaddress_part${index + 1}`).val(part);
                        });

                        if (company.address.zipCode) {
                            $('#thirdaddress_zip').tokenInput('clear');
                            $('#thirdaddress_zip').tokenInput('add', {
                                id: company.address.zipCode,
                                name: company.address.town,
                                zipcode: company.address.zipCode,
                            });
                        }
                    }

                    if (company.officers) {
                        const officer = company.officers[0];
                        $('#thirdcontact_forename').val(officer.firstname);
                        $('#thirdcontact_name').val(officer.lastname).trigger('input');
                        $('#thirdcontact_position').val(officer.role);
                    }

                    window.CompanySearch.addFinancialActivity(company.financialActivity);

                    $('[id$=corp_capital]').val(company.capital);
                    $('[id$=corp_vat]').val(company.vat);
                    $('[id$=corp_rcs]').val(company.rcs);
                    $('[id$=corp_number_of_employees]').val(
                        this.extractEmployeeRangeLowerBound(company.companyEmployeeRange),
                    );

                    $('[id$=corp_main_activity_description]').val(company.mainActivityDescription);

                    //change inputs tel country
                    $('.e164Number').intlTelInput(
                        'setCountry',
                        queryParams.countryCode.toLowerCase(),
                    );

                    this.searching = false;

                    //clear companiesResult after selected one for hide result panel.
                    this.companiesResult = null;
                },
                (error) => {
                    this.searching = false;
                    Push.error(error);
                },
            );
        },
        fillUpdatedThird(companyId, queryParams) {
            this.searching = true;

            this.fetchCompany(companyId, queryParams).then(
                (company) => {
                    var buttons = [
                        {
                            text: Loc.g('Annuler'),
                            class: 'btn btn-default',
                            click: function () {
                                $(this).dialog('close');
                            },
                        },
                        {
                            text: Loc.g('Mettre à jour'),
                            class: 'btn btn-primary',
                            click: function () {
                                $('#modalSearchForm').submit();
                            },
                        },
                    ];

                    MyWindow.addOption('buttons', buttons);

                    var thirdInfosFields = {
                        name: '',
                        siret: '',
                        siren: '',
                    };

                    $.each(thirdInfosFields, function (field, defaultValue) {
                        var updateRadio = $('input#updateThird_' + field + '_update');

                        updateRadio.attr('disabled', false).prop('checked', false);
                        if (company[field] === '') {
                            // DISPLAY
                            $('span.value_' + field).html(defaultValue);
                            // INPUT[HIDDEN]
                            $('input#updateThird_' + field + '_value').val('');
                            // RADIO BUTTON
                            updateRadio.attr('disabled', true).prop('checked', false);
                        } else {
                            // DISPLAY
                            $('span.value_' + field).html(company[field]);
                            // INPUT[HIDDEN]
                            $('input#updateThird_' + field + '_value').val(company[field]);
                            // RADIO BUTTON
                            updateRadio.prop(
                                'checked',
                                company[field] !== $('span.oldValue_' + field).html(),
                            );
                        }
                    });

                    // Name
                    if (company.name) {
                        $('input#updateThird_name_update').prop(
                            'checked',
                            $('span.oldValue_name').text() !== company.name,
                        );
                        $('span.value_name').html(company.name);
                        $('input#updateThird_name_value').val(company.name);
                    }

                    // Legal form
                    if (company.companyType) {
                        $('input#updateThird_type_update').prop(
                            'checked',
                            $('span.oldValue_type').html() !== company.companyType,
                        );
                        $('span.value_type').html(company.companyType);
                        $('input#updateThird_type_value').val(company.companyType);
                    }

                    // Company ID
                    if (company.companyId) {
                        $('input#updateThird_companyId_update').prop(
                            'checked',
                            $('span.oldValue_companyId').text() !== company.companyId,
                        );
                        $('span.value_companyId').html(company.companyId);
                        $('input#updateThird_companyId_value').val(company.companyId);
                        $('#label_companyId').text(
                            CompanySearch.getLabelForCountry('companyId', queryParams.countryCode),
                        );
                    }

                    // Siret
                    if (company.siret) {
                        $('input#updateThird_siret_update').prop(
                            'checked',
                            $('span.oldValue_siret').text() !== company.siret,
                        );
                        $('span.value_siret').html(company.siret);
                        $('input#updateThird_siret_value').val(company.siret);
                    }

                    // NAF code
                    if (company.companyJobCode) {
                        $('input#updateThird_apenaf_update').prop(
                            'checked',
                            $('span.oldValue_apenaf').text() !== company.companyJobCode,
                        );
                        $('span.value_apenaf').html(company.companyJobCode);
                        $('input#updateThird_apenaf_value').val(company.companyJobCode);
                        $('#label_apenaf').text(
                            CompanySearch.getLabelForCountry('jobCode', queryParams.countryCode),
                        );
                    }

                    // vat
                    if (company.vat) {
                        $('input#updateThird_vat_update').prop(
                            'checked',
                            $('span.oldValue_vat').text() !== company.vat,
                        );
                        $('span.value_vat').html(company.vat);
                        $('input#updateThird_vat_value').val(company.vat);
                    }

                    // Number of employees
                    const employeeRangeLowerBound = this.extractEmployeeRangeLowerBound(
                        company.companyEmployeeRange,
                    );
                    if (employeeRangeLowerBound) {
                        $('input#updateThird_number_of_employees_update').prop(
                            'checked',
                            $('span.oldValue_number_of_employees').text() !==
                                employeeRangeLowerBound,
                        );
                        $('span.value_number_of_employees').html(employeeRangeLowerBound);
                        $('input#updateThird_number_of_employees_value').val(
                            employeeRangeLowerBound,
                        );
                    }

                    // Address
                    if (company.address != '') {
                        var number = '';
                        if (company.address.number) {
                            number = company.address.number + ' ';
                        }

                        $('div.value_address').html(
                            number +
                                ' ' +
                                company.address.part1 +
                                '<br />' +
                                company.address.zipCode +
                                ' ' +
                                company.address.town +
                                '<br />' +
                                company.address.country,
                        );
                        $('input[name=thirdAddress_part1]').val(number + company.address.part1);
                        $('input[name=thirdAddress_zip]').val(company.address.zipCode);
                        $('input[name=thirdAddress_town]').val(company.address.town);
                        $('input[name=thirdAddress_country]').val(company.address.country);
                    }

                    CompanySearch.addFinancialActivity(company.financialActivity);

                    $('#third_recap').slideDown('fast', function () {
                        MyFacture.customForm('#third_recap');
                    });

                    this.searching = false;
                    //clear companiesResult after selected one for hide result panel.
                    this.companiesResult = null;
                },
                (error) => {
                    this.searching = false;
                    Push.error(error);
                },
            );
        },
        companiesFetched(payload) {
            this.companiesResult = payload.companies.map((company) => {
                company.address = this.addressFormatted(company.address);
                return company;
            });
        },
        searchCompanies(payload) {
            this.form = payload.form;
            this.searching = true;
            this.$ajax.get(
                `/companysearch/search`,
                this.form,
                (response) => {
                    if (response.companies) {
                        this.companiesResult = response.companies.map((company) => {
                            company.address = this.addressFormatted(company.address);
                            return company;
                        });
                    } else if (response.error && response.error.message) {
                        Push.error(response.error.message);
                        this.companiesResult = [];
                    } else {
                        this.companiesResult = [];
                    }

                    this.searching = false;
                },
                (error) => {
                    Push.error(window.i18n.__('Une erreur est survenue'));
                    this.searching = false;
                },
            );
        },
        countryCodeSelected(payload) {
            this.countryCode = payload.countryCode;
            this.companiesResult = null;
        },
        extractEmployeeRangeLowerBound(range) {
            if (!range) {
                return null;
            }
            const match = range.match(/^(\d+)/);
            return match ? match[1] : null;
        },
    },
};
</script>
<style lang="scss">
#companysearch-fieldset {
    min-height: 80px;
}
</style>
